export const dataHooks = {
  feature: 'feature',
  featureImage: 'featureImage',
  featureTitle: 'featureTitle',
  featureText: 'featureText',
};

export const MOBILE_COLS = 1;
